import { getHexColorBrightness } from './get-hex-color-brightness.util';
import { ColorEnum } from '../../enum/color.enum';

export function isDarkColor(colorToCheck: string): boolean {
  return colorToCheck && colorToCheck !== ColorEnum.Transparent() && getHexColorBrightness(colorToCheck) < 180;
}
